// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3oyE3","choiceBoxes":"toolbarselects_choiceBoxes__1aSxx","simpleField":"toolbarselects_simpleField__2zqYz"};